/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Warehouse_ShipmentsInputs */

const en_nav_warehouse_shipments = /** @type {(inputs: Nav_Warehouse_ShipmentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warehouse shipments`)
};

/**
* | output |
* | --- |
* | "Warehouse shipments" |
*
* @param {Nav_Warehouse_ShipmentsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_warehouse_shipments = /** @type {((inputs?: Nav_Warehouse_ShipmentsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Warehouse_ShipmentsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_warehouse_shipments(inputs)
});